import { useState, useCallback } from "react";
import { Tab, Container, Row, Col } from "react-bootstrap";

import { SubfamilyModel } from "../../models/SubfamilyModel";

import CategoryItem from "../CategoryItem/CategoryItem";
import MediaViewer from "../MediaViewer/MediaViewer";

interface Props {
  subfamily: SubfamilyModel;
}

const VariantItem = (props: Props) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [visible, setVisible] = useState(false);

  const openImageViewer = useCallback((index) => {
    setVisible(true);
    setCurrentImage(index);
  }, []);

  const closeImageViewer = () => {
    setVisible(false);
    setCurrentImage(0);
  };

  var images: { src: string }[] = [];

  return (
    <>
      <Tab.Pane eventKey={props.subfamily.name}>
        <Container className="m-0">
          <Row>
            {props.subfamily.variants.map((item, index) => {
              images.push({ src: item.profileMedia.path });
              return (
                <Col
                  xs={12}
                  md={4}
                  xl={3}
                  key={index}
                  className="d-flex justify-content-center"
                >
                  <CategoryItem
                    name={item.name}
                    primaryMedia={item.profileMedia}
                    style={{ nameClassName: "text-center" }}
                    imageViewer={() => openImageViewer(index)}
                  />
                </Col>
              );
            })}
          </Row>
        </Container>
      </Tab.Pane>
      <MediaViewer
        visible={visible}
        onClose={closeImageViewer}
        activeIndex={currentImage}
        images={images}
      />
    </>
  );
};

export default VariantItem;
